export const TOAST_CONFIG = {
  position: "bottom-right",
  closeOnClick: true,
  pauseOnHover: true,
  autoClose: 3000,
};
